import React from 'react';

const OTPVerification = () => {
  return (
    <>
     <div className='verify_account'>
        <div className='col-md-4 mx-auto bg-light'>
            <div className='shadow p-4'>
                <div>One-Time Password has been sent to your email id </div>
                <form className='w-75 mx-auto'>
                    <div className=' form-group my-4'>
                        <input type='password' className='custom-input' />
                    </div>
                    <div className='mb-3'>
                        <button type='button' className=' btn btn-primary btn-signup btn-lg'>Validate</button>
                    </div>
                    <div>Resend One-Time Password</div>
                    
                </form>
            </div>
        </div>
    </div>
    </>
  );
}

export default OTPVerification;
